module.exports = __webpack_public_path__ + "img/bell.1a4f450b.svg";